export default __webpack_public_path__ + "static/media/moreskills-2.9001b637.png";